import React, { useEffect, useState } from 'react'
import ContactInformationView from './components/ContactInformationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const ContactInformation = ({ i18n }) => {
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        try {
            addToGoogleDataLayer('contact-information', 'Pay a Debt', i18n.language)
            window.scrollTo(0, 0)
        } catch (e) {
            console.log(e)
        }
    }, [i18n.language])

    return isError ? <Error /> : <ContactInformationView setIsError={setIsError} />
}

export default withTranslation('common')(ContactInformation)
